// Domain
import {
  BaseGoalsRepository,
} from '@/modules/flagship/investor-goal/base-goals/domain/repositories/base-goals-repository';
import Injectable from '@/modules/shared/domain/di/injectable';

@Injectable()
export default class BaseGoalsDummyRepository implements BaseGoalsRepository {
  update(): Promise<void> {
    return Promise.resolve();
  }
}
